export const understandingColorSections = [
  ["introduction", "Introduction"],
  ["basics", "Color basics"],
  ["chromatic", "Chromatic & achromatic"],
  ["wheel", "The color wheel"],
  ["warm-cool", "Warm & cool colors"],
  ["variations", "Tints, shades & tones"],
  ["families", "Color families"],
  ["mood", "Color and mood"],
  ["purpose", "Color by purpose"],
  ["culture", "Cultural meaning"],
  ["business", "Business & branding"],
  ["palette", "Building a palette"],
  ["accessibility", "Contrast & accessibility"],
  ["mistakes", "Common mistakes"],
  ["quick-reference", "Quick reference"],
  ["references", "Further study"],
  ["conclusion", "Conclusion"],
] as const;
